document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.querySelector("[data-sticky-bottom-bar]");
  const studieContent = document.querySelector("[data-studie-content]");

  if (stickyBar) {
    function checkVisibility() {
      const rect = studieContent.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.top <= windowHeight - 400 && rect.bottom >= 600) {
        stickyBar.classList.add("visible");
      } else {
        stickyBar.classList.remove("visible");
      }
    }

    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);
    checkVisibility();
  }
});
